import React, { useEffect, useState } from "react";
import { Col, Form, Row, Image, Table, Container } from "react-bootstrap";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { IconButton } from "@material-ui/core";
import { useParams, useHistory } from "react-router-dom";
import { get_payment_history } from "../../../../store/actions/SuperAdminActions/superAdminManageTransactions";
import PropTypes from "prop-types";
import { connect, useDispatch } from "react-redux";
import moment from "moment";
import { Menu, MenuItem } from "@material-ui/core";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

import { FormControl, Select, InputLabel, TextField } from "@material-ui/core";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";

const payoutType = ['Order', 'Tips', 'Experience', 'Scan & Pay', 'Experience'];
const settleStatus = ['Pending', 'Settled', 'Cancelled', 'Failure', 'Reversed', 'In-Progress'];

const SuperadminPayoutHistory = (props) => {
  const history = useHistory();
  const { vendorId } = useParams();
  const [searchData, setSearch] = useState("");
  const onSuccess = () => { };
  useEffect(() => {
    const token = props.auth.user.accessToken;
    props.get_payment_history(token, vendorId, onSuccess);
  }, []);

  const [showFilter, setShowFilter] = useState(false);
  const [isActive, setActive] = useState(false);
  const [filter, setFilter] = useState({
    location: "",
    search: false,
  });
  const userFilter = [
    { title: "Low to High 🠑", disabled: false },
    { title: "High to Low 🠓", disabled: false },
    { title: "Last Settlement", disabled: true },
    { title: `Date & Time 🠑`, disabled: false },
    { title: "Date & Time 🠓", disabled: false },
  ];

  const [filterData, setFilterData] = useState({
    payout: "",
    search: false,
  });

  const filterOptions = [
    { value: "SCAN", name: "Scan & Pay" },
    { value: "ORDER", name: "Order" },
    { value: "TIP", name: "Tip" },
    { value: "Event", name: "Experience" },
  ];

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [sort, setSort] = useState("");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  let filteredData = props.payment_history;
  if (searchData !== "") {
    filteredData =
      filteredData &&
      filteredData.filter((item) => {
        return (
          item &&
          item.total_amount &&
          item.total_amount === parseInt(searchData)
        );
      });
  }

  if (sort === "Low to High 🠑") {
    filteredData = filteredData.sort((a, b) => a.total_amount - b.total_amount);
  } else if (sort === "High to Low 🠓") {
    filteredData = filteredData.sort((a, b) => b.total_amount - a.total_amount);
  }
  // else if (sort === "Date & Time 🠑") {
  //   filteredData = filteredData.sort(
  //     (a, b) => Number.parseFloat(a.scanAndPayPayAmount + a?.eventPayAmount + a?.orderPayAmount + a?.orderTipAmount).toFixed(2) - Number.parseFloat(b?.scanAndPayPayAmount + b?.eventPayAmount + b?.orderPayAmount + b?.orderTipAmount).toFixed(2)
  //   ); 
  // } else if (sort === "Date & Time 🠓") {
  //   filteredData = filteredData.sort(
  //     (a, b) => Number.parseFloat(b?.scanAndPayPayAmount + b?.eventPayAmount + b?.orderPayAmount + b?.orderTipAmount).toFixed(2) - Number.parseFloat(a?.scanAndPayPayAmount + a?.eventPayAmount + a?.orderPayAmount + a?.orderTipAmount).toFixed(2)
  //   );
  // }

  if (filterData.search) {
    if (filterData.payout === "ORDER")
      filteredData = filteredData.filter((ele) => ele.payout_type === 0);
    else if (filterData.payout === "SCAN")
      filteredData = filteredData.filter((ele) => ele.payout_type == 3);
    else if (filterData.payout === "TIP")
      filteredData = filteredData.filter((ele) => ele.payout_type == 1);
    else if (filterData.payout === "EVENT")
      filteredData = filteredData.filter((ele) => ele.payout_type == 2);
  }

  const downloadData = {
    headers: [
      { label: "Restaurant Id", key: "id" },
      { label: "Total Payble Amount", key: "total" },
      { label: "Last Settlement Date", key: "lastDate" },
      { label: "Last Settlement Amount", key: "lastAmount" },
      { label: "Period", key: "period" },
      { label: "Total Comission", key: "comission" },
      { label: "Status", key: "status" },
      { label: "Payout For", key: "for" },
    ],
    data: filteredData
      ? filteredData?.map((ele) => {
        return {
          id: ele?.restaurant_id,
          total: ele?.total_amount,
          lastDate: moment(ele?.createdAt).format("lll"),
          lastAmount: ele?.lastSettledAmount,
          period: `${moment(ele?.payoutStartDate).format(
            "DD MMM , YYYY"
          )} - ${moment(ele?.payoutEndDate).format("DD MMM , YYYY")}`,
          comission: ele?.totalEarnedComission,
          status: settleStatus[ele.settle_payment_status],
          for: payoutType[ele?.payout_type]
        };
      })
      : [],
  };

  return (
    <React.Fragment>
      {props.auth.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="container-fluid">
            <div className="row">
              <div className="left-side-panel">
                <LeftSideNavigation displayLink={1} />
              </div>
              <div className="super-admin-right-side-panel">
                <HomeReusableTopBarNavigation
                  backIcon
                  link="/superadminopenitemsettlement"
                  displayText="Back"
                />
                <Container fluid>
                  <div className="col-12 pr-5">
                    <div className="super_admin_add_vendor mb-4">
                      <h5 className="main_header_text">Payout History</h5>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-5">
                      <div className="d-flex align-items-center">
                        <div className="mr-3">
                          <img
                            //src="https://amealia.s3.amazonaws.com/1616416724030-media-desktop-candle-light-dining-at-radisson-hitech-city-2020-7-2-t-13-4-37.jpg"
                            // src={
                            //   history?.location?.state?.data?.restaurant_id
                            //     ?.logo_url
                            // }
                            src={props?.data?.logo_url}
                            width="85px"
                            alt="restaurant logo"
                            title="restaurant logo"
                          />
                        </div>
                        <div>
                          <div className="f20-700">
                            {" "}
                            {
                              props?.data?.restaurant_name
                            }
                          </div>
                          <div className="f18-500">
                            {
                              props?.data?.restaurant_address
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <Row className="mt-2">
                    <Col md={5}>

                      {/* <div className="col-9 p-0">
                            <Form.Control
                              type="text"
                              placeholder="Payout amount"
                              onChange={(e) => setSearch(e.target.value)}
                              value={searchData}
                              className="amSearch w-100"
                            />
                          </div> */}
                      <div className="d-flex align-items-center">
                        <div
                          className={`newexpandablesearch pr-4 ${isActive ? "active" : null
                            }`}
                        >
                          <div className="searchicon">
                            <i
                              onClick={() => setActive(!isActive)}
                              className="fa fa-search"
                              aria-hidden="true"
                              style={{ fontSize: "20px" }}
                            ></i>
                          </div>
                          <div className="input">
                            <Form.Control
                              type="text"
                              placeholder="Payout amount"
                              className="newsearchinput"
                              onChange={(e) => setSearch(e.target.value)}
                              value={searchData}
                              style={{ borderRadius: "28px" }}
                            />
                            <i
                              className="fa fa-timesw"
                              aria-hidden="true"
                            ></i>
                          </div>
                        </div>
                        <div
                          className="f10-400"
                          align="center"
                          aria-controls="simple-menu"
                          aria-haspopup="true"
                          onClick={handleClick}
                        >
                          <img
                            src={require("../../../../assets/images/iconButton/sortbtn.svg")}
                            width="80px"
                          />
                        </div>
                        <Menu
                          id="simple-menu"
                          anchorEl={anchorEl}
                          keepMounted
                          open={Boolean(anchorEl)}
                          onClose={handleClose}
                        >
                          {userFilter.map((ele, index) => {
                            return (
                              <MenuItem
                                value={ele.title}
                                key={index}
                                onClick={() => setSort(ele.title)}
                                disabled={ele.disabled}
                              >
                                {ele.title}
                              </MenuItem>
                            );
                          })}
                        </Menu>
                        <div className="f10-400" align="center">
                          <img
                            src={require("../../../../assets/images/iconButton/filterbtn.svg")}
                            width="80px"
                            alt="Filter Icon"
                            onClick={() => setShowFilter(!showFilter)}
                          />
                        </div>
                        <CSVDownloader
                          filename={"settlement-history"}
                          headers={downloadData.headers}
                          data={downloadData.data}
                        />
                      </div>
                    </Col>
                    <Col md={6}></Col>
                  </Row>
                  {showFilter && (
                    <div
                      className="container-fluid p-4"
                      style={{
                        backgroundColor: "#ffffff",
                        transition: "height 2s",
                      }}
                    >
                      <Row>
                        <Col md={6}>
                          <Form.Group>
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Status">
                                Payout For
                              </InputLabel>
                              <Select
                                value={filterData.payout}
                                onChange={(e) =>
                                  setFilterData({
                                    ...filterData,
                                    payout: e.target.value,
                                  })
                                }
                                label="payout"
                                inputProps={{
                                  name: "payout",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {filterOptions?.map((ele) => (
                                  <MenuItem value={ele.value} key={ele.value}>
                                    {ele.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Form.Group>
                        </Col>
                      </Row>
                      <div className="mt-5 d-flex">
                        <button
                          type="button"
                          className="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                          title="Cancel Button"
                          onClick={() => {
                            setFilter({
                              payout: "",
                              search: false,
                            });
                            setShowFilter(!showFilter);
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                          title="Confirm Button"
                          onClick={() => {
                            setFilterData({ ...filterData, search: true });
                            setShowFilter(!showFilter);
                          }}
                        >
                          Apply Filter
                        </button>
                      </div>
                    </div>
                  )}
                  <div>
                    <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                      <Table>
                        <thead>
                          <TableHead />
                        </thead>
                        {filteredData &&
                          filteredData.map((item, index) => (
                            <TableBody key={index} itemData={item} />
                          ))}
                      </Table>
                    </div>
                  </div>
                </Container>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

SuperadminPayoutHistory.propTypes = {
  auth: PropTypes.object.isRequired,
  get_payment_history: PropTypes.func.isRequired,
  data: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  payment_history: state.superadminManageTransactions.payment_history,
  data: state.superadminManageTransactions.single_vendor_settllement,
});

export default connect(mapStateToProps, {
  get_payment_history,
})(SuperadminPayoutHistory);

const TableHead = (props) => {
  return (
    <tr>
      <td style={{ width: "15%" }}>
        Restaurant
        <br />
        ID
      </td>
      <td style={{ width: "15%" }}>
        Total Payable
        <br />
        Amount
      </td>
      <td style={{ width: "18%" }}>
        Last Settlement <br />
        Date & Time
      </td>
      <td style={{ width: "10%" }}>
        Last Payout
        <br />
        Amount
      </td>
      <td style={{ width: "10%" }}>Period</td>
      <td style={{ width: "10%" }}>
        Total Earned
        <br />
        Comission
      </td>
      <td style={{ width: "10%" }}>Status</td>
      <td style={{ width: "12%" }}>
        Payout
        <br />
        For
      </td>
    </tr>
  );
};

const TableBody = (props) => {
  return (
    <React.Fragment>
      <tbody>
        <tr className="super_admin_all_users_table_body">
          <td className="text-break" style={{ width: "15%" }}>
            <div className="f14-500 text-break">
              {props.itemData && props.itemData.restaurant_id}
            </div>
          </td>
          <td className="text-break" style={{ width: "15%" }}>
            <div className="f15-500">
              ₹ {props.itemData && props.itemData.settlement_amount.toFixed(2)}
            </div>
          </td>
          <td style={{ width: "18%" }}>
            <div className="f14-500">
              {moment(props.itemData && props.itemData.createdAt).format(
                "DD MMM , YYYY"
              )}
              <br />
              {moment(props.itemData && props.itemData.createdAt).format("LT")}
            </div>
          </td>
          <td style={{ width: "10%" }}>
            <div className="f15-500">
              ₹{" "}
              {props.itemData &&
                parseFloat(props.itemData.lastSettledAmount).toFixed(2)}
            </div>
          </td>
          <td style={{ width: "10%" }}>
            <div className="f15-500">
              {moment(props.itemData && props.itemData.payoutStartDate).format(
                "DD MMM , YYYY"
              )}
              <br />
              {moment(props.itemData && props.itemData.payoutEndDate).format(
                "DD MMM , YYYY"
              )}
            </div>
          </td>
          <td style={{ width: "10%" }}>
            <div className="f14-500">
              {props?.itemData?.payout_type === 1 ? " - " : (
                <>
                  ₹{" "}
                  {props.itemData && props.itemData.totalEarnedComission.toFixed(2)}
                </>
              )}
            </div>
          </td>
          <td style={{ width: "10%" }}>
            <div
              // style={{borderRadius:"50px"}}
              className={`badge p-2  ${props.itemData &&
                props.itemData &&
                props.itemData.settle_payment_status === 1
                ? "badge-success"
                : (props.itemData &&
                  props.itemData &&
                  props.itemData.settle_payment_status === 0) ||
                  (props.itemData &&
                    props.itemData &&
                    props.itemData.settle_payment_status === 2)
                  ? "badge-warning"
                  : props.itemData &&
                    props.itemData &&
                    props.itemData.settle_payment_status === 3
                    ? "badge-danger"
                    : props?.itemData?.settle_payment_status === 4
                      ? "badge-warning" : "badge-warning"
                }`}
            >
              {settleStatus[props.itemData.settle_payment_status]}
            </div>
          </td>
          <td style={{ width: "12%" }}>
            <div className="f14-500">
              {payoutType[props?.itemData?.payout_type]}
            </div>
          </td>
        </tr>
      </tbody>
    </React.Fragment>
  );
};
